

















































import { POSFmiByResource } from '@pos/interfaces/pos-v2';
import PosAccessControlService from '@pos/services/pos-access-control-service';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcTable from '@shared/components/tables/table.vue';
import BpcPosFmiAddPassageModal from './pos-fmi-add-passage-modal.vue';

@Component({
  name: 'bpc-pos-fmi-by-resource',
  components: {
    BpcTable,
    BpcPosFmiAddPassageModal,
  },
})
export default class PosFmiByResource extends Vue {
  // PROPS
  @Prop({ type: Number, required: true }) readonly posSessionId: number;

  // DATA
  fmiByResource: POSFmiByResource[] = [];
  loading = false;
  openFmiAddPassageModal = false;
  selectedResourceId = 0;
  FieldsToShowInTable = [
    {
      key: 'name',
      headerLabel: 'pos.fmi.resource_name.label',
      thStyle: { width: '60%' },
    },
    {
      key: 'capacity',
      headerLabel: 'pos.fmi.capacity.label',
      labelClass: 'text-right',
      class: 'text-right',
    },
    {
      key: 'fmi',
      headerLabel: 'pos.fmi.fmi.label',
      labelClass: 'text-right',
      class: 'text-right',
    },
    { key: 'ocupation', headerLabel: 'pos.fmi.ocupation.label', labelClass: 'text-right mr-3' },
    { key: 'addPassage', headerLabel: 'pos.fmi.add_passage.label', labelClass: 'text-right mr-3' },
  ];
  // COMPUTED
  get accessControlService(): PosAccessControlService {
    return this.$posService.accessControl;
  }

  // LIFE CYCLE
  mounted() {
    this.getFmiByResource();
    this.listenForFmiChanges();
  }

  listenForFmiChanges() {
    this.accessControlService
      .getFmiChangesChannel()

      .listen(
        '.BPC\\Centers\\Events\\ResourceFmiUpdated',
        async (data: { posResourceFmi: POSFmiByResource }) => {
          const resourceFmi = data.posResourceFmi;
          if (!resourceFmi) {
            return;
          }
          if (resourceFmi.show_in_pos) {
            const index = this.fmiByResource.findIndex(fmi => fmi.id === resourceFmi.id);
            if (index !== -1) {
              const fmiByResource = this.fmiByResource.map(fmi => {
                if (fmi.id === resourceFmi.id) {
                  return resourceFmi;
                }
                return fmi;
              });
              this.fmiByResource = [...fmiByResource];
            } else {
              this.fmiByResource.push(resourceFmi);
            }
          }
        },
      );
  }
  // METHODS
  async getFmiByResource() {
    this.loading = true;
    this.fmiByResource = await this.accessControlService.getFmiByResource(this.posSessionId);
    this.loading = false;
    console.log('getFmiByResource', this.fmiByResource);
  }

  closeModalFmiAddPassage() {
    this.openFmiAddPassageModal = false;
  }

  onOpenFmiAddPassage(resourceId) {
    //this.$refs.fmiAddEntriesModal.onOpenModal(fmiResource);
    this.selectedResourceId = resourceId;
    this.openFmiAddPassageModal = true;
  }
}
